import * as React from "react";
import "../Styles/style.css";
import { useEffect, useState } from "react";
import axios from "axios";
// import baseUrl from "../../api/ipconfig";
import MyadsNavigation from "./myads-navigation";
import UserDetails from "./userDetails";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import InnerLoader from "../loader/innerLoader";
import baseUrl from "../../api/ipconfig";
import { AuthContext } from "../../context/AuthContext";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function SearchInspection() {
  const { user } = React.useContext(AuthContext);

  const [inspectionHistory, setInspectionHistory] = useState([]);
  const [chassisNo, setChassisNo] = useState([]);
  const [open, setOpen] = React.useState(false);
  // const [statusMsg, setStatusMsg] = useState("");
  const [isLoading, setLoading] = useState(false);

  const handleBarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  // const user = localStorage.getItem("data");
  // const userId = JSON.parse(user);

  const fetchBiddingHistory = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(`${baseUrl}/getInspectionsByChassis`, {
        params: {
          chassis_no: chassisNo,
          userId: user?.id,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setInspectionHistory(response?.data?.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching inspection history", error);
    }
  };

  const handleButtonClick = (token) => {
    window.open(
      `https://www.inspectionreport.famewheels.com/inspection-report/${token}`,
    );
  };

  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleBarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleBarClose}
          severity="success"
          sx={{ width: "100%" }}
        ></Alert>
      </Snackbar>
      <div className="MyAds_main">
        <UserDetails />
        <div className="container-md MyAds_body">
          <div className="row pb-5">
            <div className="col-lg-2 p-0">
              <MyadsNavigation />
            </div>
            <div className="col-lg-10 ">
              <div className="row mb-2">
                <div className="col-12">
                  <div className="input-group searchBar">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Chassis Number"
                      aria-label="Recipient's username"
                      aria-describedby="basic-addon2"
                      required
                      onChange={(e) => setChassisNo(e.target.value)}
                    />
                    <div className="m-auto pe-3 btnArea">
                      <Button
                        // type="submit"
                        variant="contained"
                        className=" bgSecondary color-white text-capitalize px-5 py-3"
                        onClick={() => fetchBiddingHistory()}
                      >
                        SEARCH
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              {isLoading ? (
                <InnerLoader />
              ) : inspectionHistory?.length ? (
                <>
                  <div className=" bgSecondary boxShadow mb-3 ">
                    <div className="row paymentHistory_header">
                      <div className="col-lg-2 col-2">
                        <h6>Date</h6>
                      </div>
                      <div className="col-lg-2 col-2">
                        <h6>Chassis No.</h6>
                      </div>
                      <div className="col-lg-2 col-2">
                        <h6>Registered No.</h6>
                      </div>
                      <div className="col-lg-2 col-2">
                        <h6>Mileage</h6>
                      </div>

                      <div className="col-lg-3 col-3"></div>
                    </div>
                  </div>
                  {inspectionHistory?.map((item) => (
                    <div className=" bg-white paymentHistory_list boxShadow mb-3">
                      <div className="row align-items-center py-2 ms-2">
                        <div className="col-lg-2 col-2">
                          <p>{item?.created_at.split(" ")[0]}</p>
                        </div>
                        <div className="col-lg-2 col-2">
                          <p>{item?.iinitial_chassisno}</p>
                        </div>
                        <div className="col-lg-2 col-2">
                          <p>{item?.iinitial_registeredno}</p>
                        </div>
                        <div className="col-lg-2 col-2">
                          <p> {item?.iinitial_mileage} </p>
                        </div>

                        <div className="col-lg-3 col-3 d-flex justify-content-end ">
                          <Button
                            variant="contained"
                            className=" bgSecondary color-white me-3"
                            onClick={() =>
                              handleButtonClick(item?.iinitial_token)
                            }
                          >
                            View
                          </Button>
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <div className="adsSection">
                  <div className="No_ads text-center">
                    <p>no history available</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
